import React, {memo, useCallback, useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router';
import {Link} from 'react-router-dom';
import {CgMenuGridR} from 'react-icons/cg';
import './_leftMenu.scss';
import axios from 'axios';
import {API_URL} from '../../../redux/services/user.service';

function LeftMenu(props) {
    const [showMenu, setShowMenu] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const [menuListData, setMenuListData] = useState({});

    useEffect(() => {
        setShowMenu(false);
    }, [location]);

    const handleMenuItemsPosition = useCallback(({logo, menu, headLine, mobileMatch}) => {
        const currentScrollY = window.scrollY;
        const desktopHeight = window.innerHeight;

        if (mobileMatch) {
            logo.style.transform = currentScrollY < desktopHeight - 100 ? 'scale(1)' : 'scale(0.4)';
            headLine.style.opacity = currentScrollY < desktopHeight - 100 ? 0 : 1;
        } else {
            logo.style.opacity = currentScrollY < desktopHeight ? 0 : 1;
        }
        menu.style.opacity = currentScrollY < desktopHeight - 450 ? 1 : 0;
    }, []);

    useEffect(() => {
        const logo = document.getElementById('menuLogo');
        const menu = document.getElementById('hiddenLeftMenu');
        const headLine = document.getElementById('headLine');
        const mobileMatch = window.matchMedia(`(max-width: 480px)`).matches;

        window.addEventListener(
            'scroll',
            () => handleMenuItemsPosition({logo, menu, headLine, mobileMatch}),
            false
        );
        return () => window.removeEventListener('scroll', handleMenuItemsPosition);
    }, []);

    const handleShowMenu = () => {
        setShowMenu(!showMenu);
    };

    useEffect(() => {
        document.body.style.overflow = showMenu ? 'hidden' : 'auto';
    }, [showMenu]);

    const handleMouse = useCallback((event, sublink) => {
        const links = document.querySelectorAll('.menuLinkItem');
        if (
            event.type === 'mousemove' ||
            event.type === 'mouseenter' ||
            event.type === 'mouseover'
        ) {
            for (let i = 0; i < links.length; i++) {
                links[i].style.opacity = '0.35';
            }
            event.target.style.opacity = '1';
            if (sublink === 'sublink') {
                const headLink = event.target
                    .closest('ul')
                    .closest('li')
                    .querySelector('.headLink');
                headLink.style.opacity = '1';
            }
        } else if (event.type === 'mouseout') {
            for (let i = 0; i < links.length; i++) {
                links[i].style.opacity = '1';
            }
        }
    }, []);

    useEffect(() => {
        axios.get(`${API_URL}/pages/menu/list`).then((data) => {
            setMenuListData(data.data);
        });
    }, []);

    return (
        <>
            <div className={`leftMenu ${showMenu ? 'menuOpen' : ''}`}>
                <div className='menuIcon' onClick={handleShowMenu}>
                    {/* <SVG src='leftMenuIcon' /> */}

                    <CgMenuGridR/>
                </div>
                <div
                    id='hiddenLeftMenu'
                    className={`leftMenu hidden ${showMenu ? 'menuOpen' : ''}`}
                >
                    <div className='menuIcon' onClick={handleShowMenu}>
                        {/* <SVG src='leftMenuIcon' /> */}

                        <CgMenuGridR/>
                    </div>
                </div>
            </div>
            <div className={`leftMenuBody ${showMenu ? 'showMenu' : ''}`}>
                <div className='leftMenuContent'>
                    <Link
                        to='/'
                        className='logo'
                        style={{
                            backgroundImage: 'url(/media/images/InClassicaColorLogo.png)',
                        }}
                    />
                    <div className='menuLinks'>
                        <ul>
                            {menuListData?.left_column?.map((menuItem, i) => (
                                <li key={i}>
                                    {menuItem.external ? (
                                        <a
                                            onMouseOver={handleMouse}
                                            onMouseOut={handleMouse}
                                            className='menuLinkItem headLink'
                                            href={menuItem.link}
                                            rel='noreferrer noopener'
                                            target='_blank'
                                            dangerouslySetInnerHTML={{__html: menuItem.title}}
                                        />
                                    ) : (
                                        <Link
                                            onMouseOver={handleMouse}
                                            onMouseOut={handleMouse}
                                            className={`menuLinkItem headLink ${
                                                `/${location.pathname.split('/')[1]}` === menuItem.link
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            to={menuItem.link}
                                            dangerouslySetInnerHTML={{__html: menuItem.title}}
                                        />
                                    )}
                                    {menuItem.subLink.length !== 0 && (
                                        <ul>
                                            {menuItem.subLink.map((subLinkItem, j) => (
                                                <li key={j}>
                                                    <Link
                                                        onMouseOver={(e) => handleMouse(e, 'sublink')}
                                                        onMouseOut={(e) => handleMouse(e, 'sublink')}
                                                        className='menuLinkItem'
                                                        to={subLinkItem.link}
                                                        dangerouslySetInnerHTML={{
                                                            __html: subLinkItem.title,
                                                        }}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>

                        <ul>
                            {menuListData?.right_column?.map((menuItem, i) => {
                                return menuItem.link === '/search' ? (
                                    <li key={i}>
                                        <label
                                            htmlFor='topSearchBar'
                                            onMouseOver={handleMouse}
                                            onMouseOut={handleMouse}
                                            className='menuLinkItem headLink d-md-none'
                                            onClick={(e) => {
                                                if (history.location.pathname.match(/search/gi)) {
                                                    window.scroll({
                                                        top: 100,
                                                        left: 0,
                                                        behavior: 'smooth',
                                                    });
                                                    document
                                                        .querySelector('.search__form__field__input')
                                                        .focus();
                                                    setShowMenu(false);
                                                    return;
                                                }
                                                props.setIsFocused(true);
                                                props.setShowSearch(true);
                                            }}
                                            dangerouslySetInnerHTML={{__html: menuItem.title}}
                                        />
                                    </li>
                                ) : (
                                    <li key={i}>
                                        {menuItem.external ? (
                                            <a
                                                onMouseOver={handleMouse}
                                                onMouseOut={handleMouse}
                                                className='menuLinkItem headLink'
                                                href={menuItem.link}
                                                rel='noreferrer noopener'
                                                target='_blank'
                                                dangerouslySetInnerHTML={{__html: menuItem.title}}
                                            />
                                        ) : (
                                            <Link
                                                onMouseOver={handleMouse}
                                                onMouseOut={handleMouse}
                                                className={`menuLinkItem headLink ${
                                                    `/${location.pathname.split('/')[1]}` ===
                                                    menuItem.link
                                                        ? 'active'
                                                        : ''
                                                }`}
                                                to={menuItem.link}
                                                dangerouslySetInnerHTML={{__html: menuItem.title}}
                                            />
                                        )}
                                        {menuItem.subLink.length !== 0 && (
                                            <ul>
                                                {menuItem.subLink.map((subLinkItem, j) => (
                                                    <li key={j}>
                                                        <Link
                                                            onMouseOver={(e) => handleMouse(e, 'sublink')}
                                                            onMouseOut={(e) => handleMouse(e, 'sublink')}
                                                            className='menuLinkItem'
                                                            to={subLinkItem.link}
                                                            dangerouslySetInnerHTML={{
                                                                __html: subLinkItem.title,
                                                            }}
                                                        />
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>

                        <div className='socialSectionMenu'>
                            <div>
                                <p className='shadowText'>call us</p>
                                <p>
                                    <a href='tel:+356 27877705'>+356 27877705</a>
                                </p>
                                <p className='shadowText'>write us</p>
                                <p>
                                    <a
                                        href='mailto:info@inclassica.com'
                                        target='_blank'
                                        rel='noreferrer noopener'
                                    >
                                        info@inclassica.com
                                    </a>
                                </p>
                            </div>
                            <div className='d-flex justify-content-end socialIcons'>
                                <a
                                    href='https://www.facebook.com/inclassicafestival'
                                    rel='noopener noreferrer'
                                    target='_blank'
                                    className='facebook-icon footerIcon'
                                />
                                {/* <a href='#' target='_blank' className='youtube-icon footerIcon'/> */}
                                {/* <a href='#' target='_blank' className='instagram-icon footerIcon'/> */}
                            </div>
                        </div>
                    </div>
                    <div className='closeMenuDiv' onClick={() => setShowMenu(false)}/>
                </div>
            </div>
            <div className='menuLogoContainer'>
                <Link to='/' className='menuLogo' id='menuLogo'/>
            </div>
            <div className='headLine' id='headLine'/>
        </>
    );
}

export default memo(LeftMenu);
